import React, { memo, VFC } from 'react';
import T from 'i18n-react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Icon from './Icon';
import type { NearbyPlaceProps } from '../types';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';

type Props = NearbyPlaceProps & {
  isNearbyPlaceUnavailable: boolean;
};

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    marginBottom: theme.spacing(1.5),
  },
  text: {
    marginLeft: theme.spacing(1),
  },
  disabled: {
    color: theme.palette.text.secondary,
    textDecoration: 'line-through',
    textDecorationColor: 'black',
  },
}));

const PlaceListItem: VFC<Props> = memo(
  ({
    name,
    kind,
    isAvailable,
    minutesOnFoot,
    isNearbyPlaceUnavailable,
  }: Props) => {
    const classes = useStyles();

    // 項目を選択している、かつ「あてはまるものはない」を選択していない場合に表示する
    const value = isAvailable && !isNearbyPlaceUnavailable;

    return (
      <Grid item xs={12} container classes={{ root: classes.root }}>
        <Grid item>
          <Icon kind={kind} />
        </Grid>
        <Grid
          item
          classes={{
            root: clsx(!value && classes.disabled, classes.text),
          }}
        >
          <span>{name}</span>
          {value && (
            <span>
              {T.translate('planPage.nearbyPlaces.minutesOnFoot', {
                minutes: minutesOnFoot,
              })}
            </span>
          )}
        </Grid>
      </Grid>
    );
  },
);

export default PlaceListItem;
